/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_StrikethroughInputs */

const en_common_editor_strikethrough = /** @type {(inputs: Common_Editor_StrikethroughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strikethrough`)
};

const zh_common_editor_strikethrough = /** @type {(inputs: Common_Editor_StrikethroughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除线`)
};

/**
* | output |
* | --- |
* | "Strikethrough" |
*
* @param {Common_Editor_StrikethroughInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_strikethrough = /** @type {((inputs?: Common_Editor_StrikethroughInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_StrikethroughInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_strikethrough(inputs)
	return zh_common_editor_strikethrough(inputs)
});
export { common_editor_strikethrough as "common.editor.strikethrough" }